//查看最接近哪个
function closeTo(arr, num) {
    var newArr = [];
    arr.map(function (x) {
        newArr.push(Math.abs(x - num));
    });
    var index = newArr.indexOf(Math.min.apply(null, newArr));
    return arr[index];
}

//图片处理
function formatImage(src) {
    if (!src) {
        return src;
    }
    const isDev = process.env.NODE_ENV === 'development';
    const ossPrefix = 'lvshuhualv.oss-cn-hangzhou.aliyuncs.com';
    if (isDev) {
        if (/^https?:\/\//i.test(src)) {
            const url = new URL(src);
            if (url.host === ossPrefix) {
                return '/oss' + url.pathname + url.search;
            }
            return encodeURI(src);
        }
        if (src.startsWith('//')) {
            const url = new URL('https:' + src);
            if (url.host === ossPrefix) {
                return '/oss' + url.pathname + url.search;
            }
            return encodeURI(src);
        }
        return encodeURI('/oss/' + src.replace(/^\/+/, ''));
    }
    if (/^https?:\/\//i.test(src) || src.startsWith('//')) {
        return encodeURI(src);
    }
    return encodeURI('//lvshuhualv.oss-cn-hangzhou.aliyuncs.com/' + src);
}

//删除
function reomveObjectFromScene(scene, object) {
    if (!object) {
        return;
    }
    if (object.parent) {
        object.parent.remove(object);
    } else {
        scene.remove(object);
    }
    if (object.traverse) {
        object.traverse(disposeThreeNode);
        return;
    }
    scene.remove(object);
    if (object.geometry) {
        object.geometry.dispose();
    }
    if (object.material && object.material.map) {
        object.material.map.dispose();
    }
    if (object.material) {
        object.material.dispose();
    }
    object = null;
}

function disposeTexture(texture) {
    if (texture && texture.isTexture) {
        texture.dispose();
    }
}

function disposeMaterial(material) {
    if (!material) {
        return;
    }
    const textureKeys = [
        'map',
        'alphaMap',
        'aoMap',
        'bumpMap',
        'displacementMap',
        'emissiveMap',
        'envMap',
        'gradientMap',
        'lightMap',
        'metalnessMap',
        'normalMap',
        'roughnessMap',
        'specularMap'
    ];

    for (let key of textureKeys) {
        disposeTexture(material[key]);
    }

    if (material.uniforms) {
        for (let key in material.uniforms) {
            const uniform = material.uniforms[key];
            if (!uniform) {
                continue;
            }
            disposeTexture(uniform.value);
        }
    }

    material.dispose();
}

function disposeThreeNode(node) {
    if (!node) {
        return;
    }
    if (node.geometry) {
        node.geometry.dispose();
    }
    const materials = Array.isArray(node.material) ? node.material : [node.material];
    for (let material of materials) {
        disposeMaterial(material);
    }
}

function removeTreeFromScene(scene, object) {
    if (!object) {
        return;
    }
    scene.remove(object);
    object.traverse(disposeThreeNode);
}

//选中花
function selectFlower(event) {
    const getParentObject = (target) => {
        let node = target;
        while (node && !node.parentObject) {
            node = node.parent;
        }
        return node ? node.parentObject : null;
    };
    let pointer = new THREE.Vector2(),
        ray = new THREE.Raycaster();
    let objects = [];
    for (let obj of this.objects.flowers) {
        if ((!this.params.showId || (this.params.showId && this.params.showId === obj.id)) && obj.modelMesh.flowerMesh) {
            objects.push(obj.modelMesh.pickHelperMesh || obj.modelMesh.touchHelperMesh || obj.modelMesh.flowerMesh);
        }
    }
    const rect = this.params.dom.getBoundingClientRect();
    pointer.x = ((event.clientX - rect.left) / rect.width) * 2 - 1;
    pointer.y = -((event.clientY - rect.top) / rect.height) * 2 + 1;
    ray.setFromCamera(pointer, this.three.camera);

    const raycasterObjs = ray.intersectObjects(objects, true);
    if (raycasterObjs.length) {
        const flowerObject = getParentObject(raycasterObjs[0].object);
        if (flowerObject) {
            this.selectFlowerById(flowerObject.id, event);
            return;
        }
    } else if (event.type === 'pointerdown') {
        this.clearFlowerSelection();
    }
}

export { closeTo, formatImage, reomveObjectFromScene, removeTreeFromScene, selectFlower };
